// src/api/mockData.js

export const mockPosts = [
  {
    id: 1,
    title: '春日郊游手记：樱花树下的野餐哲学',
    summary: '上周末和朋友们在公园的樱花树下进行了一场计划已久的野餐，从食物准备到游戏选择，原来让一次户外聚会变好玩有这么多小心思。',
    content: `# 春日郊游手记：樱花树下的野餐哲学

上周末的天气好得不像话，我们终于执行了拖延两周的野餐计划。

## 野餐筹备清单

1. **食物**: 三明治、饭团、颜色鲜艳的水果拼盘（拍照好看！）
2. **饮品**: 自制柠檬薄荷苏打、一壶热红茶
3. **道具**: 格子野餐垫、蓝牙小音箱、扑克牌、一本轻便的书
4. **氛围**: 最重要的是——一群能聊得来的朋友

当粉白色的樱花花瓣偶尔飘落到盘子里时，感觉连食物都多了几分诗意。

\`\`\`
野餐幸福感 = （好天气 + 美食 + 美景） × 好心情
\`\`\`

> 生活需要一些这样的“无意义”时刻，专门用来浪费美好时光。`,
    author: '旅行的小张',
    date: '2024-03-15',
    tags: ['生活随笔', '户外活动', '春日', '美食'],
    views: 1560,
    likes: 128
  },
  {
    id: 2,
    title: '在古镇咖啡馆消磨的一个下午',
    summary: '逃离城市快节奏，在江南古镇偶然发现一家临河的咖啡馆。木窗、旧书、手冲咖啡的香气，还有一只爱打瞌睡的猫掌柜。',
    content: `# 在古镇咖啡馆消磨的一个下午

这家咖啡馆没有显眼的招牌，走过青石板路，循着咖啡香才能找到。

推开木门，风铃轻响。老板在吧台后专注地冲着手冲咖啡，一只橘猫在窗边的阳光下睡成一团毛球。

## 我的观察清单

- 临河的窗边座位是最佳选择
- 书架上有不少老板的私藏旧书，可以随意取阅
- 咖啡单很简单，但每种豆子他都说得出一个故事
- 那只叫“拿铁”的猫，下午三点准时在沙发上打盹

时间在这里变得很慢，慢到可以数清阳光透过窗格移动的轨迹。

坐在这里，好像明白了什么叫“偷得浮生半日闲”。`,
    author: '爱喝咖啡的Lisa',
    date: '2024-03-10',
    tags: ['旅行见闻', '咖啡馆', '慢生活', '古镇'],
    views: 2243,
    likes: 201
  },
  {
    id: 3,
    title: '重温《星际穿越》：关于爱与时间的永恒命题',
    summary: '第五次看诺兰的《星际穿越》，每次都有新发现。这次特别注意到父亲与女儿之间的情感线索，在宏大科幻背景下依然如此动人。',
    content: `# 重温《星际穿越》：关于爱与时间的永恒命题

科幻的外壳，情感的核。这是我对《星际穿越》最深的感受。

## 那些击中我的瞬间

1. **库珀看儿子长大录像**：几分钟内见证孩子二十多年的人生
2. **“不要温和地走进那个良夜”** 诗歌在片中的反复出现
3. **墨菲最终解出方程** 与父亲在五维空间传递信息的呼应
4. **“因为我曾经是你的幽灵”** 当一切线索最终收束

\`\`\`javascript
// 如果用代码表达电影的核心关系？
const love = {
  dimension: 'transcends',
  time: 'bends',
  message: 'STAY',
  solution: 'Gravity + Love'
};
\`\`\`

好的科幻电影，最终讲的都是最朴素的人类情感。`,
    author: '电影爱好者Mike',
    date: '2024-03-05',
    tags: ['电影评论', '科幻', '情感', '诺兰'],
    views: 1897,
    likes: 176
  },
  {
    id: 4,
    title: '阳台种植初体验：从种子到番茄的奇妙旅程',
    summary: '在五平米的小阳台上开始了我的城市农夫的尝试。看着番茄从一粒小小的种子，慢慢发芽、开花、结果，这种成就感无与伦比。',
    content: `# 阳台种植初体验：从种子到番茄的奇妙旅程

## 种植时间线

**第1周**：种子泡水，等待发芽
**第2-3周**：冒出两片可爱的小子叶
**第1个月**：长出了真叶，需要移栽到更大的盆里
**第2个月**：开出了黄色的小花！
**第3个月**：青色的番茄果实出现了
**现在**：第一个番茄变红了！

## 学到的经验

- 阳光和水都要适量，不是越多越好
- 适当的修剪能让植株更健康
- 每天早上去看看它们，是一天中最治愈的时刻

当我把第一个成熟的番茄摘下来做成沙拉时，感觉比买来的香一百倍！

城市里的田园梦，就从一个小花盆开始。`,
    author: '绿植新手阿宁',
    date: '2024-02-28',
    tags: ['种植', '阳台花园', '生活技能', '治愈'],
    views: 1320,
    likes: 98
  }
];

export const mockUser = {
  id: 1,
  username: '文艺生活家',
  email: 'hello@example.com',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
};